export enum EventStateFilter {
	ALL = "",
	LIVE = "live",
	TODAY = "today",
	FUTURE = "future",
	PAST = "past",
}
